import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { ytgGateway } from "@modules/ytg/api/gatewayFacade";
import type { OperationMetaItem } from "@modules/gateway/api/gateway.service";

/** Return shape of {@link useYtgOperationMeta}. */
export interface UseYtgOperationMetaReturn {
    data: OperationMetaItem | undefined;
    loading: boolean;
    error: Error | null;
    /** Re-run the operation-meta query. */
    refetch: UseQueryResult<OperationMetaItem>["refetch"];
}

/**
 * Query hook returning the gateway-side metadata of a YTG operation
 * (upload/PDF flags) by its YTG operation id. Disabled when the id is nullish.
 */
export const useYtgOperationMeta = (
    ytgOperationId: number | string | null | undefined,
): UseYtgOperationMetaReturn => {
    const { data, isLoading, error, refetch } = useQuery<OperationMetaItem>({
        queryKey: ["ytg", "operation-meta", ytgOperationId],
        queryFn: ({ signal }) => ytgGateway.getOperationMeta(ytgOperationId!, { signal }),
        enabled: Boolean(ytgOperationId),
    });
    return { data, loading: isLoading, error, refetch };
};
